module.exports = __webpack_public_path__ + "static/main-fb47030df314e6f57abf91f3357966ef.png";